export const PERCENT_25 = 0.25
export const PERCENT_50 = 0.5
export const PERCENT_75 = 0.75
export const PERCENT_100 = 1
export const MAX_PERCENTAGE = 100
export const ATTACHMENT_SELECTOR = '.lecture-attachment'
export const VIDEO_ATTACHMENT_SELECTOR = '.attachment-wistia-player'
